<template>
	
	<div
		:class="{
					'app_wrapper': mapStatus == 1,
					'': mapStatus == 0,
					'': mapStatus == 2,
				}"
		v-show="!$store.state.isMain">
				
		

			<div :class="{
							'map_side_wrapper nearbymapContainer': mapStatus == 1,
							'no_map_wrapper nearbymapContainer': mapStatus == 0,
							'map_full_wrapper nearbymapContainer': mapStatus == 2
						}">
						<MapDiv ref="map" id="map" />

						<button 
							title="בחירה לפי הצבעה" 
							class="selectAssetBtn"
							style="position: absolute; top: 20px; right: 10px; z-index: 9;"
							@click="allowMapSelection('Point')">
							<div :class="{
							'map-action-after': true,
							'active': $store.state.mapSelectionType == 'Point'
							}" v-show="$store.state.mapStatus > 0">
							<svg height="35" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.416 9.95615C21.1115 10.2487 20.9167 10.614 20.8327 10.9982C20.0759 10.6168 19.1267 10.7309 18.4813 11.3509C18.1768 11.6435 17.982 12.0088 17.898 12.393C17.1412 12.0116 16.192 12.1256 15.5467 12.7457C15.277 13.0048 15.0934 13.3209 14.9973 13.6569L12.6701 11.2348C11.8848 10.4175 10.5816 10.3914 9.76439 11.1767C8.94713 11.9619 8.92108 13.2651 9.70631 14.0823L18.0291 22.7446L15.0134 23.6828C14.5593 23.8241 14.1379 24.0737 13.7948 24.4033C13.0139 25.1536 12.9897 26.398 13.7436 27.1827C14.1074 27.5613 14.5958 27.7745 15.1203 27.785L24.5143 27.9728C26.6376 28.0159 28.6518 27.2277 30.184 25.7555C32.8395 23.2041 32.9242 18.9677 30.3728 16.3122L24.3217 10.0142C23.5365 9.19697 22.2333 9.17092 21.416 9.95615ZM29.6318 17.0241C31.791 19.2713 31.7186 22.8561 29.4713 25.0153C28.1369 26.2974 26.3842 26.9825 24.5348 26.9442L15.1402 26.7571C14.891 26.7528 14.6576 26.6508 14.4803 26.4663C14.123 26.0944 14.1348 25.5016 14.5067 25.1443C14.7357 24.9243 15.0159 24.7591 15.3193 24.6641L19.1285 23.478C19.2981 23.4247 19.4295 23.2871 19.4729 23.1157C19.5171 22.9437 19.4691 22.7603 19.3459 22.6321L10.4473 13.3704C10.055 12.9622 10.0673 12.3106 10.4763 11.9176C10.8853 11.5247 11.5369 11.5384 11.9291 11.9467L18.6921 18.9855C18.8886 19.19 19.214 19.1965 19.4185 19.0001C19.623 18.8036 19.6295 18.4781 19.4331 18.2736L16.2295 14.9394C15.8373 14.5312 15.8496 13.8796 16.2586 13.4866C16.6676 13.0937 17.3192 13.1074 17.7114 13.5157L20.9149 16.8499C21.1114 17.0544 21.4368 17.0609 21.6413 16.8644C21.8458 16.6679 21.8523 16.3424 21.6559 16.1379L19.1642 13.5447C18.772 13.1364 18.7843 12.4848 19.1933 12.0919C19.6023 11.6989 20.2538 11.7127 20.6461 12.1209L23.1377 14.7142C23.3342 14.9187 23.6596 14.9252 23.8641 14.7287C24.0686 14.5322 24.0751 14.2068 23.8787 14.0023L22.0989 12.1499C21.7066 11.7416 21.7189 11.0901 22.1279 10.6971C22.5369 10.3041 23.1885 10.3179 23.5807 10.7261L29.6318 17.0241Z" fill="#1C1C1C"></path><path d="M5.81327 9.8814C6.092 9.24242 6.49385 8.6646 6.99589 8.18092C7.49793 7.69724 8.09032 7.31718 8.73924 7.06245C9.38816 6.80771 10.0809 6.68328 10.7779 6.69627C11.4749 6.70925 12.1625 6.85939 12.8015 7.13812C13.4031 7.40054 13.9505 7.7721 14.4161 8.23366L13.532 9.08549C13.1784 8.73983 12.7647 8.46106 12.3108 8.26308C11.8196 8.0488 11.2909 7.93337 10.7551 7.92338C10.2192 7.9134 9.68661 8.00906 9.18772 8.20491C8.68883 8.40075 8.2334 8.69293 7.84743 9.06479C7.46146 9.43664 7.15252 9.88087 6.93823 10.3721C6.72394 10.8634 6.60851 11.392 6.59853 11.9279C6.58855 12.4637 6.68421 12.9963 6.88005 13.4952C7.06098 13.9561 7.32415 14.3799 7.6564 14.7462L6.77223 15.598C6.32834 15.1155 5.97742 14.5546 5.73759 13.9437C5.48285 13.2948 5.35842 12.602 5.37141 11.905C5.38439 11.208 5.53454 10.5204 5.81327 9.8814Z" fill="#1C1C1C" stroke="white" stroke-width="0.244585"></path></svg>
							</div>
						</button>

						<button title="בחירה לפי תיחום"
							class="selectAssetBtn"
							style="position: absolute; top: 20px; right: 60px; z-index: 9;"
							@click="allowMapSelection('Rectangle')">
							<div :class="{
							'map-action-after': true,
							'active': $store.state.mapSelectionType == 'Rectangle'
							}" v-show="$store.state.mapStatus > 0">
							<svg data-v-53f5f9b6="" height="35" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
								<circle data-v-53f5f9b6="" cx="7.42871" cy="9.57141" r="2" stroke="#1C1C1C" fill="none"></circle>
								<circle data-v-53f5f9b6="" cx="31.4287" cy="28.4285" r="2" stroke="#1C1C1C" fill="none"></circle>
								<circle data-v-53f5f9b6="" cx="31.4287" cy="9.57141" r="2" stroke="#1C1C1C" fill="none"></circle>
								<circle data-v-53f5f9b6="" cx="7.42871" cy="28.4285" r="2" stroke="#1C1C1C" fill="none"></circle>
								<line data-v-53f5f9b6="" x1="31.5715" y1="25.0714" x2="31.5715" y2="13.0714" stroke="#1C1C1C"></line>
								<line data-v-53f5f9b6="" x1="7.42871" y1="25.0714" x2="7.42871" y2="13.0714" stroke="#1C1C1C"></line>
								<line data-v-53f5f9b6="" x1="11" y1="28.5" x2="28" y2="28.5" stroke="#1C1C1C"></line>
								<line data-v-53f5f9b6="" x1="11" y1="9.57141" x2="28" y2="9.57141" stroke="#1C1C1C"></line>
							</svg>
							</div>
						</button>



						<button title="חזרה לבחירה במפה"
							class="selectAssetBtn"
							style="position: absolute; top: 20px; right: 110px; z-index: 9;"
							@click="zoomToSelection()">
							<div :class="{
							'map-action-after': true,
							}" v-show="$store.state.mapStatus > 0">
							<svg xmlns="http://www.w3.org/2000/svg" height="25px" viewBox="0 -960 960 960" fill="#5f6368"><path d="M480-380q-41.92 0-70.96-29.04Q380-438.08 380-480q0-41.92 29.04-70.96Q438.08-580 480-580q41.92 0 70.96 29.04Q580-521.92 580-480q0 41.92-29.04 70.96Q521.92-380 480-380Zm0-60q17 0 28.5-11.5T520-480q0-17-11.5-28.5T480-520q-17 0-28.5 11.5T440-480q0 17 11.5 28.5T480-440ZM212.31-140Q182-140 161-161q-21-21-21-51.31V-360h60v147.69q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85H360v60H212.31ZM600-140v-60h147.69q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46V-360h60v147.69Q820-182 799-161q-21 21-51.31 21H600ZM140-600v-147.69Q140-778 161-799q21-21 51.31-21H360v60H212.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46V-600h-60Zm620 0v-147.69q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H600v-60h147.69Q778-820 799-799q21 21 21 51.31V-600h-60Z"/></svg>
						</div>
						</button>

						
					
					</div>


					
			<div :class="{
				'info_side': mapStatus == 1,
				'': mapStatus == 0,
				'': mapStatus == 2
			}" >
			
			
			<div class="hello">
				<div v-if="$store.state.loading == true" class="loading-container">
					<svg viewBox="25 25 50 50" class="loader-svg">
						<circle
							class="loader-path"
							cx="50"
							cy="50"
							r="20"
							fill="none"
							stroke="#1990d4"
							stroke-width="2"
						/>
					</svg>
				</div>

				<div class="content">
					<div 
						:class="{'nadlan-page  mainAppPage': $store.state.polygonIds.length == 0,
								'nadlan-page  mainAppPage mainAppPageMap': $store.state.polygonIds.length > 0,}"
						v-show="$store.state.loading == false">
						<BreadCrumbs v-if="$store.state.polygonIds.length == 0"></BreadCrumbs>
						<div class="buyerDealsComp innerPage">
							<section v-if="$store.state.polygonIds.length == 0" class="trendsSection sectionPadBottom">
								<div class="container-fluid">
									<div class="whiteContainer" v-if="$store.state.polygonIds.length == 0">
										<div class="titleContainer">
											<h2 class="title">מגמות המחירים ב{{ summaryTypeName }}</h2>
											<p class="plainText">בהתייחס לשנה האחרונה</p>
										</div>
										<TrendCards></TrendCards>
										<div class="bottomTrends">
											<div class="titleTabsWrap">
												<h3 class="title">מגמות לפי מספר חדרים</h3>
											</div>

											<div class="tab-content">
												<div
													role="tabpanel"
													aria-hidden="false"
													class="fade tab-pane active show"
												>
													<!-- new component -->
													<TargetContainer ref="target_container"></TargetContainer>
													<!-- end new component -->
												</div>
											</div>
										</div>
									</div>
								</div>
							</section>

							<section class="transactionsSection">
								<div class="transactions container-fluid sectionPadBottom">
									<div v-if="$store.state.polygonIds.length == 0">
										<h2 v-if="checkRouteType == 'neighborhood'" class="title">
											עסקאות ב{{ resultTypeDesc }} {{ $store.state.neighborhoodName }}
										</h2>
										<h2 v-if="checkRouteType == 'settlement'" class="title">
											עסקאות ב{{ resultTypeDesc }} {{ $store.state.settlementName }}
										</h2>
										<h2
											v-if="
												checkRouteType == 'address' || checkRouteType == 'kparcel_all'
											"
											class="title"
										>
											עסקאות ב{{ resultTypeDesc }} {{ checkAddress }},
											{{ $store.state.settlementName }}
										</h2>

									</div>
									<div v-else  style="display: flex;justify-content: space-around;align-items: center;margin-bottom: 30px;">
										
										<h2 class="title" style="width: calc(100% - 60px); padding-bottom:0px">
											עסקאות ב{{ resultTypeDesc }}
										</h2>

										<button @click="setDefaultMap()" title="ביטול בחירה"
											class="map-action-after " style="margin: 10px;">
											<div data-font-size="10" data-font-size-type="px" >
												<svg xmlns="http://www.w3.org/2000/svg"   viewBox="0 -960 960 960" width="34px" fill="#5f6368"><path d="m487.69-160-28.31-28.31 142-142-142-142 28.31-28.31 142 142 142-142L800-472.31l-142 142 142 142L771.69-160l-142-142-142 142Zm-180 0v-49.23h49.23V-160h-49.23Zm-98.46-590.77H160q0-20.31 14.46-34.77Q188.92-800 209.23-800v49.23Zm98.46 0V-800h49.23v49.23h-49.23Zm147.69 0V-800h49.24v49.23h-49.24Zm147.7 0V-800h49.23v49.23h-49.23Zm147.69 0V-800q20.31 0 34.77 14.46Q800-771.08 800-750.77h-49.23ZM209.23-209.23V-160q-20.31 0-34.77-14.46Q160-188.92 160-209.23h49.23ZM160-307.69v-49.23h49.23v49.23H160Zm0-147.69v-49.24h49.23v49.24H160Zm0-147.7v-49.23h49.23v49.23H160Zm590.77 0v-49.23H800v49.23h-49.23Z"/></svg>
												<!-- <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#02234b"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"></path></svg> -->
												<!-- <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.07692 3H16.1538C17.3009 3 18.2308 3.92987 18.2308 5.07692V11.1344C18.2308 11.6101 17.6409 11.8927 17.2095 11.6923C16.998 11.594 16.8462 11.3881 16.8462 11.1549V5.07692C16.8462 4.69457 16.5362 4.38462 16.1538 4.38462H5.07692C4.69457 4.38462 4.38462 4.69457 4.38462 5.07692V16.1538C4.38462 16.5362 4.69457 16.8462 5.07692 16.8462H11.1549C11.3881 16.8462 11.594 16.998 11.6923 17.2095C11.8927 17.6409 11.6101 18.2308 11.1344 18.2308H5.07692C3.92987 18.2308 3 17.3009 3 16.1538V5.07692C3 3.92987 3.92987 3 5.07692 3ZM6.11538 5.76923C5.92421 5.76923 5.76923 5.92421 5.76923 6.11538V6.80769C5.76923 6.99887 5.92421 7.15385 6.11538 7.15385H6.80769C6.99887 7.15385 7.15385 6.99887 7.15385 6.80769V6.11538C7.15385 5.92421 6.99887 5.76923 6.80769 5.76923H6.11538ZM19.2973 15.6486C19.2973 13.6336 17.6637 12 15.6487 12C13.6336 12 12 13.6336 12 15.6486C12 17.6637 13.6336 19.2973 15.6487 19.2973C16.4806 19.2973 17.2475 19.0188 17.8613 18.5501L20.1695 20.8575L20.2154 20.898C20.4062 21.0464 20.6821 21.0329 20.8575 20.8575C21.0475 20.6675 21.0475 20.3595 20.8575 20.1695L18.5501 17.8613C19.0188 17.2475 19.2973 16.4806 19.2973 15.6486ZM12.973 15.6486C12.973 14.1709 14.1709 12.973 15.6487 12.973C17.1264 12.973 18.3243 14.1709 18.3243 15.6486C18.3243 17.1264 17.1264 18.3243 15.6487 18.3243C14.1709 18.3243 12.973 17.1264 12.973 15.6486ZM5.76923 8.88462C5.76923 8.69344 5.92421 8.53846 6.11538 8.53846H6.80769C6.99887 8.53846 7.15385 8.69344 7.15385 8.88462V9.57692C7.15385 9.7681 6.99887 9.92308 6.80769 9.92308H6.11538C5.92421 9.92308 5.76923 9.7681 5.76923 9.57692V8.88462ZM6.11538 11.3077C5.92421 11.3077 5.76923 11.4627 5.76923 11.6538V12.3462C5.76923 12.5373 5.92421 12.6923 6.11538 12.6923H6.80769C6.99887 12.6923 7.15385 12.5373 7.15385 12.3462V11.6538C7.15385 11.4627 6.99887 11.3077 6.80769 11.3077H6.11538ZM5.76923 14.4231C5.76923 14.2319 5.92421 14.0769 6.11538 14.0769H6.80769C6.99887 14.0769 7.15385 14.2319 7.15385 14.4231V15.1154C7.15385 15.3066 6.99887 15.4615 6.80769 15.4615H6.11538C5.92421 15.4615 5.76923 15.3066 5.76923 15.1154V14.4231ZM8.19231 5.76923C8.00113 5.76923 7.84615 5.92421 7.84615 6.11538V6.80769C7.84615 6.99887 8.00113 7.15385 8.19231 7.15385H15.1154C15.3066 7.15385 15.4615 6.99887 15.4615 6.80769V6.11538C15.4615 5.92421 15.3066 5.76923 15.1154 5.76923H8.19231ZM7.84615 8.88462C7.84615 8.69344 8.00113 8.53846 8.19231 8.53846H15.1154C15.3066 8.53846 15.4615 8.69344 15.4615 8.88462V9.57692C15.4615 9.7681 15.3066 9.92308 15.1154 9.92308H8.19231C8.00113 9.92308 7.84615 9.7681 7.84615 9.57692V8.88462ZM10.7173 14.0769C11.1208 14.0769 11.4067 14.4697 11.3496 14.8692C11.304 15.1888 11.0459 15.4615 10.723 15.4615H8.19231C8.00113 15.4615 7.84615 15.3066 7.84615 15.1154V14.4231C7.84615 14.2319 8.00113 14.0769 8.19231 14.0769H10.7173ZM8.19228 11.3076C8.00111 11.3076 7.84613 11.4626 7.84613 11.6538V12.3461C7.84613 12.5373 8.00111 12.6922 8.19228 12.6922H12.1394C12.2832 12.6922 12.4118 12.6394 12.5089 12.5334C12.8946 12.1128 12.7387 11.3084 12.168 11.3078L12 11.3076H8.19228Z" fill="#595959"></path></svg> -->
											</div>
										</button>

									</div>


									<TableAction></TableAction>


									<TableBox></TableBox>
								</div>
							</section>

							<AdditionalDeals
								ref="additional_deals"
								v-show="checkRouteType.startsWith('address') &&
										$store.state.polygonIds.length == 0"
							/>

							<NeighScroller
								v-show="$store.state.similarNeighborhoods.length > 0 &&
										$store.state.polygonIds.length == 0"
								ref="neigh_scroller"
							/>
						</div>
					</div>
				</div>

		
				<footer
				class="footer" 
				
				v-if="$store.state.loading == false "
			>
				<div class="personalArea">
					<h3 class="title">עסקאות חדשות לידי? יש פרויקט חדש בשכונה?</h3>
					<p class="plainText">
						קבלו מידע עדכני על סביבת המגורים שלכם ישירות למייל
					</p>
				</div>
				<button @click="$parent.$parent.showRegister()" class="btn blue round">
					הירשמו לקבלת עדכונים
				</button>
				<ul class="footerLinks">
					<li class="linkWrap">
						<button type="button" @click="$parent.$parent.showContact()" class="link">
							יצירת קשר
						</button>
					</li>
					<li class="linkWrap">
						<button class="link" @click="$parent.$parent.goToTerms()">תנאי שימוש</button>
					</li>
					<li class="linkWrap">
						<button class="link" @click="$parent.$parent.goToAccess()">נגישות</button>
					</li>
					<li class="linkWrap">
						<button class="link" @click="$parent.$parent.goToAbout()">אודות</button>
					</li>
				</ul>
			</footer>
			</div>





		</div>




		<div
			v-if="showContactMsg == true"
			role="dialog"
			aria-modal="true"
			class="fade contanctModal centerModal smModal titleContainer modal show"
			tabindex="-1"
			aria-labelledby="contained-modal-title-vcenter"
			style="display: block"
		>
			<div
				v-if="showContactMsg == true"
				class="modal-dialog modal-lg modal-dialog-centered"
			>
				<div class="modal-content">

					<div class="modalHeader contanctContainer">
						<h3 class="title">{{ contactText }}</h3>
						<button style="position: absolute; top: 10px; left: 10px;"
						@click="showContactMsg = false"
						type="button"
						class="closeModalBtnContainer"
					>
						<span class="closeModalBtn" aria-hidden="true"></span
						><span class="sr-only">Close</span>
					</button>
					</div>
				</div>
			</div>
		</div>


		
	
	
	</div>
</template>

<script>
import MapDiv from "./Map";
import NeighScroller from "./NeighScroller";
import AdditionalDeals from "./AdditionalDeals";
import TargetContainer from "./TargetContainer";
import BreadCrumbs from "./BreadCrumbs";
import TrendCards from "./TrendCards";
import TableAction from "./TableAction";
import TableBox from "./TableBox";

export default {
	name: "DealsComp",
	props: {
		msg: String,
	},
	components: {
		MapDiv,
		NeighScroller,
		AdditionalDeals,
		TargetContainer,
		BreadCrumbs,
		TrendCards,
		TableAction,
		TableBox,
	},
	data() {
		return {
			contactText: "",
			showContactMsg: false,
			filteredStreets: [],
			selectedIndex: -1,
			selectedStreet: null,
			street_search: "",
			showSuggestions: false,

			isRecaptchaValid: false,
			currentTab: "all",
			allData: [],
			nameHere: "",
			typePage: "",

			initialFilter: false,
			inProgress: false,
			total_rows: 0,
			currentPage: 1,
			transactions: [],
			totalPages: 0,
			currentTransactions: [],
			currentFetchNumber: 1,
			base_id: 0,
			base_name: "",
			hok_hamecher: "",
			deal_nature: "",
			deal_date: "",

			showShare: false,
			dealNatureIndex: null,
			filter_rooms_hovered: false,
			sort_hovered: false,
			filter_hovered: false,
			countDealsAll: 0,
			centerIndex: -1,
			scrollPosition: 0,
			contentWidth: 0,
			showFilterOptions: false,
			dealsPeriodOptions1: [
				{ value: "all", text: "כל העסקאות מכל הזמנים" },
				{ value: "3months", text: "3 חודשים אחרונים" },
				{ value: "6months", text: "חצי שנה האחרונה" },
				{ value: "year", text: "שנה האחרונה" },
				{ value: "5years", text: "חמש שנים האחרונות" },
			],
			dealsPeriodOptions: [
				{ value: "", text: "כל העסקאות מכל הזמנים" },
				{ value: "3", text: "3 חודשים אחרונים" },
				{ value: "6", text: "חצי שנה האחרונה" },
				{ value: "12", text: "שנה האחרונה" },
				{ value: "60", text: "חמש שנים האחרונות" },
			],
			selectedDealsPeriod: "כל העסקאות מכל הזמנים",
			showDealsPeriods: false,
			selectedAssetType: "כל סוגי הנכסים",
			showAssetTypes: false,
			assetTypeOptions: [
				{ value: "all", text: "כל סוגי הנכסים" },
				{ value: "apartment", text: "דירה" },
				{ value: "penthouse", text: "פנטהאוז" },
				{ value: "private_house", text: "בית פרטי" },
				{ value: "commercial", text: "מסחר" },
				{ value: "other", text: "שונות" },
			],
			showDealTypes: false,
			dealTypeOptions: [
				{ value: "all", text: "כל העסקאות" },
				{ value: "first_hand", text: "יד ראשונה" },
				{ value: "second_hand", text: "יד שניה" },
			],
			selectedDealType: "כל העסקאות",
			similarNeighborhoods: [],
			otherNeighborhoodStreets: [],
			activeIndex: 0,

			sortOptions1: [
				{ value: "dateDesc", text: "תאריך עסקה - סדר יורד" },
				{ value: "dateAsc", text: "תאריך עסקה - סדר עולה" },
				{ value: "priceDesc", text: "מחיר העסקה - סדר יורד" },
				{ value: "priceAsc", text: "מחיר העסקה - סדר עולה" },
				{ value: "roomNumDesc", text: "מס' חדרים - סדר יורד" },
				{ value: "roomNumAsc", text: "מס' חדרים - סדר עולה" },
			],
			sortOptions: [
				{ value: "dealDate_down", text: "תאריך עסקה - סדר יורד" },
				{ value: "dealDate_up", text: "תאריך עסקה - סדר עולה" },
				{ value: "dealAmount_down", text: "מחיר העסקה - סדר יורד" },
				{ value: "dealAmount_up", text: "מחיר העסקה - סדר עולה" },
				{ value: "roomNum_down", text: "מס' חדרים - סדר יורד" },
				{ value: "roomNum_up", text: "מס' חדרים - סדר עולה" },
			],

			selectedSortOption: "dateDesc",
			roomOptions: [
				{ value: 1, image: "/images/1rooms.png", text: "1 חדרים" },
				{ value: 2, image: "/images/2rooms.png", text: "2 חדרים" },
				{ value: 3, image: "/images/3rooms.png", text: "3 חדרים" },
				{ value: 4, image: "/images/4rooms.png", text: "4 חדרים" },
				{ value: 5, image: "/images/5rooms.png", text: "5 חדרים" },
				{ value: 6, image: "/images/6rooms.png", text: "6+ חדרים" },
			],
			showRoomsMenu: false,
			tabs: [
				{ key: "all", label: "כל החדרים" },
				{ key: "3", label: "3 חדרים" },
				{ key: "4", label: "4 חדרים" },
				{ key: "5", label: "5 חדרים" },
			],
			selectedTab: "all",
			toggle_exclusive: 0,
			luxury: null,
			priceIncreases: null,
			Yield: null,

			lastYearAvgPrice: null,
			lastYearAvgPrice_3: null,
			lastYearAvgPrice_4: null,
			lastYearAvgPrice_5: null,

			selectedRow: null,
			colspan: 2,
			selected_deals: [],
			page: 1,
			total: 0,
			selectedRooms: [],
			showSort: false,
			sortType: null,

			mapSet: false,
		};
	},
	methods: {
		zoomToSelection(){
			var appVue = this;
			if (appVue.$store.state.polygonIds.length > 0) {
				govmap.searchInLayer({
					layerName: "KSHTANN_ASSETS_STATIC",
					fieldName: "POLYGON_ID",
					fieldValues: appVue.$store.state.polygonIds,
					highlight: true,
				})
				// .then(function (e) {
				// 	console.log(e);
				// });
			}
			else{
				// no polygonIds
				// if query param view = address || kparcel_all
				var params;
				var view = appVue.$store.state.view;
				if (view == "address" || view == "kparcel_all") {
					// search and zoom
					params = {
						layerName: "KSHTANN_ASSETS",
						fieldName: "POLYGON_ID",
						fieldValues: [appVue.$store.state.polygonId],
						highlight: true,
						outLineColor: [0, 0, 255, 1],
						fillColor: [0, 0, 255, 0.3],
					};
					govmap.searchInLayer(params);
				}
				//view=neighborhood
				else if (view == "neighborhood") {
					// filter and zoom
					params = {
						layerName: "KSHTANN_NEIGHBORHOODS",
						whereClause: "UNIQ_ID = " + appVue.$route.query.id, // + appVue.$route.params.neighborhoodId,
						zoomToExtent: true,
					};
					govmap.filterLayers(params);
				}
				//view=settlement
				else if (view == "settlement") {
					// filter and zoom
					params = {
						layerName: "KSHTANN_SETL_AREA",
						whereClause: "SETL_CODE = " + appVue.$store.state.setlCode, //appVue.$route.params.setlCode,
						zoomToExtent: true,
					};
					govmap.filterLayers(params);
				}
				//view=street
				else if (view == "street") {
					// filter and zoom
					params = {
						layerName: "KSHTANN_STREETS",
						whereClause: "STR_ID = " + appVue.$store.state.streetCode,
						zoomToExtent: true,
					};
					govmap.filterLayers(params);
				}
			}

		},
		setDefaultMap(){
			this.$store.state.polygonIds = [];
			this.$store.state.polygonSetlCode = null;
			this.$store.state.mapSelectionType = null;
			this.$store.state.mapSelectionAllowed = false;
			this.contactText = "";
			this.mixin_setMap(this);
			govmap.clearDrawings();
			govmap.clearSelection();
			this.fetchData();


		},
		allowMapSelection(selectionType) {
			var appVue = this;
			this.contactText = "";
			appVue.$store.state.currentPage = 1;
			appVue.currentPage = 1;
			// Reomve all filters
			appVue.selectedRooms = [];
			appVue.selectedDealType = "כל העסקאות";
			appVue.selectedAssetType = "כל סוגי הנכסים";
			appVue.selectedSortOption = "dateDesc";
			appVue.selectedDealsPeriod = "כל העסקאות מכל הזמנים";

			appVue.$store.state.currentPage = 1;
			// Reomve all filters
			appVue.$store.state.selectedRooms = [];
			appVue.$store.state.selectedDealType = "כל העסקאות";
			appVue.$store.state.selectedAssetType = "כל סוגי הנכסים";
			appVue.$store.state.selectedSortOption = "dateDesc";
			appVue.$store.state.selectedDealsPeriod = "כל העסקאות מכל הזמנים";

			// clear slection in ASSETS_STATIC
			//govmap.clearSelection();

			// tuggle mapSelectionAllowed from store
			if (this.$store.state.mapSelectionType == selectionType) {
				this.$store.state.mapSelectionAllowed = !this.$store.state.mapSelectionAllowed;
			} else {
				this.$store.state.mapSelectionAllowed = true;
			}
			//this.$store.state.mapSelectionAllowed = !this.$store.state.mapSelectionAllowed;
		
			//hide neighborhood layer
			var layersOn = ["KSHTANN_ASSETS_STATIC", "KSHTANN_SETL_AREA"];
			var layersOff = ["KSHTANN_NEIGHBORHOODS"];
			govmap.setVisibleLayers(layersOn, layersOff)

			// Expand all the features in KSHTANN_SETL_AREA
			govmap.filterLayers({
				layerName: "KSHTANN_SETL_AREA",
				whereClause: "SETL_CODE IS NOT NULL",
				zoomToExtent: false,
			});
			// Expand all the features in assets layer
			govmap.filterLayers({
				layerName: "KSHTANN_ASSETS_STATIC",
				whereClause: "POLYGON_ID IS NOT NULL",
				zoomToExtent: false,
			});

			if (this.$store.state.mapSelectionAllowed) {
				this.$store.state.mapSelectionType = selectionType;
				var s_types = {
					Point: govmap.geometryType.POINT,
					Polygon: govmap.geometryType.POLYGON,
					Rectangle: govmap.geometryType.CIRCLE,
				};
				//console.log(selectionType);
				govmap.draw(s_types[selectionType]).progress(function (response) {
					//console.log(response);				
					// INTERSECT WKT WITH SETL_AREA

					// TO DO = SEND /deal/ the WKT... Post to the server
					
					//console.log(response.wkt);
					govmap.intersectFeatures({
						'geometry': response.wkt,
						'layerName': "KSHTANN_SETL_AREA",
						'fields': ["SETL_CODE", "SETL_NAME"],
						getShapes: false,
					}).then(function (e) {
						if (e.data == null) {
							//alert("לא נמצאו יישובים באזור הנבחר");
							appVue.contactText = "לא נמצאו יישובים באזור הנבחר";
							appVue.showContactMsg = true;
							return;
						}
						else if (e.data.length > 1) {
							//alert("נא לסמן בתחום הישוב בלבד");
							appVue.contactText = "נא לסמן בתחום הישוב בלבד";
							appVue.showContactMsg = true;
							return;
						}
						else{
							appVue.$store.state.polygonSetlCode = e.data[0].Values[0];
							// TO DO => INTERSECT WKT TO GET POLYGON_IDS FROM SERVER (Fetch)
							// INSTEAD OF INTERSECTING WITH KSHTANN_ASSETS_STATIC

							govmap.intersectFeatures({
								'geometry': response.wkt,
								'layerName': "KSHTANN_ASSETS_STATIC",
								'fields': ["POLYGON_ID"],
								getShapes: false,
							}).then(function (e) {
								if (e.data == null) {
									//alert("לא נמצאו נכסים באזור הנבחר");
									appVue.contactText = "לא נמצאו נכסים באזור הנבחר";
									appVue.showContactMsg = true;
									return;
								}
								else if (e.data.length == 500) {
									//alert("נא לבחור אזור קטן יותר");
									appVue.contactText = "נא לבחור אזור קטן יותר";
									appVue.showContactMsg = true;
									return;
								}
								appVue.$store.state.polygonIds = e.data.map(function (item) {
									return item.Values[0];
								});
								govmap.searchInLayer({
									layerName: "KSHTANN_ASSETS_STATIC",
									fieldName: "POLYGON_ID",
									fieldValues: appVue.$store.state.polygonIds,
									highlight: true,
								})
								// .then(function (e) {
								// 	console.log(e);
								// });

								// fetch the deals from the server with the polygon_ids...
								appVue.$store.state.currentPage = 1;
								// Reomve all filters
								appVue.$store.state.selectedRooms = [];
								appVue.$store.state.selectedDealType = "כל העסקאות";
								appVue.$store.state.selectedAssetType = "כל סוגי הנכסים";
								appVue.$store.state.selectedSortOption = "dateDesc";
								appVue.$store.state.selectedDealsPeriod = "כל העסקאות מכל הזמנים";


								appVue.currentPage = 1;
								// Reomve all filters
								appVue.selectedRooms = [];
								appVue.selectedDealType = "כל העסקאות";
								appVue.selectedAssetType = "כל סוגי הנכסים";
								appVue.selectedSortOption = "dateDesc";
								appVue.selectedDealsPeriod = "כל העסקאות מכל הזמנים";

								appVue.fetchData();
								//go to the top of the page (no need to smooth scroll)
								window.scrollTo({ top: 0, behavior: 'auto'});
								appVue.$store.state.mapSelectionAllowed = false;
								appVue.allowMapSelection(selectionType);	
								
								//check if the device is mobile
								if (window.innerWidth < 768) {
									// App.vue -> ShowMap()
									appVue.$parent.$parent.ShowMap();
								}
							});		
						}
					});		
					govmap.clearDrawings();
				});
			}
			else{
				this.$store.state.mapSelectionAllowed = false;
				this.$store.state.mapSelectionType = null;
				govmap.setDefaultTool();
			}
			//this.mixin_setMap(this);
		},
		dissallowMapSelection() {
			govmap.clearSelection();
			this.$store.state.mapSelectionAllowed = false;
			//this.mixin_setMap(this);
		},
		PageIsAddressOrParcel()  {//black
			if ((this.$route.query.view == "address" || this.$route.query.view == "parcel") && this.$store.state.polygonIds.length == 0) {
				//black
				return true;
			}
			// blue
			return false;
		},
		cancelStreetsFilter() {
			// this.selectedStreet = {
			// 	title: 'כל הרחובות',
			// 	id: 0,
			// };
			if (this.selectedStreet != null) {
				this.selectedStreet = null;
				this.fetchData();
			}
			this.street_search = "";
			this.showSuggestions = false;
		},
		handleKeyDown(e) {
			if (e.key === "ArrowDown") {
				if (!this.showSuggestions) {
					this.showAllItems();
				}
				this.showSuggestions = true;
				this.moveSelection(1);
			} else if (e.key === "ArrowUp") {
				this.showSuggestions = true;
				this.moveSelection(-1);
			} else if (e.key === "Enter") {
				this.selectCurrentItem(this.selectedIndex);
				// focus out of the input via vanilla js
				document.getElementById("street_search").blur();
			} else if (event.key === "Backspace") {
				// Clear the input model if Backspace is pressed and the input is already empty
				// if (this.filteredStreets.some(item => item.title === this.street_search)) {
				// 	//this.cancelStreetsFilter();
				// 	//this.street_search = '';
				// 	this.showSuggestions = false;
				// }
				if (this.street_search === "") {
					// take first 10 items from streets
					this.filteredStreets = this.streets;
					this.showSuggestions = true;
				}
			}
		},
		filterList() {
			if (this.street_search == "") {
				this.showSuggestions = false;
				this.filteredStreets = [];
				return;
			}
			this.showSuggestions = true;
			this.selectedIndex = -1;
			this.filteredStreets = this.streets.filter((street) => {
				return street.title
					.toLowerCase()
					.includes(this.street_search.toLowerCase());
			});
		},
		showAllItems() {
			//console.log('focus: showAllItems');
			this.street_search = "";
			this.filteredStreets = this.streets;
			this.showSuggestions = true;
		},
		highlightText(text, query) {
			// eslint-disable-next-line
			/* eslint-disable */
			const sanitizedQuery = query.trim().replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
			const regex = new RegExp(`(${sanitizedQuery})`, "gi");
			//console.log('highlightText', text.replace(regex, '<span class="highlight-blue">$1</span>'));
			return text.replace(regex, '<span class="highlight-blue">$1</span>');
		},
		selectCurrentItem(selectedIndex) {
			if (selectedIndex >= 0 && selectedIndex < this.filteredStreets.length) {
				//this.selectItem(this.items[this.selectedIndex]);
				this.filterDealsStreets(this.filteredStreets[selectedIndex]);
			} else {
				// get item 0 if exists..
				if (this.filteredStreets.length > 0) {
					this.filterDealsStreets(this.filteredStreets[0]);
				}
			}
		},
		moveSelection(direction) {
			if (this.filteredStreets.length === 0) return;

			this.selectedIndex += direction;

			// Ensure the selectedIndex wraps around appropriately
			if (this.selectedIndex < 0) {
				this.selectedIndex = this.filteredStreets.length - 1;
			} else if (this.selectedIndex >= this.filteredStreets.length) {
				this.selectedIndex = 0;
			}

			// Optionally, scroll the selected item into view
			this.$nextTick(() => {
				const selectedElement = document.querySelector(
					`.react-autosuggest__suggestion[data-suggestion-index="${this.selectedIndex}"]`,
				);
				if (selectedElement) {
					selectedElement.scrollIntoView({ block: "nearest" });
				}
			});
		},
		filterDealsStreets(street) {
			this.showSuggestions = false;
			this.selectedStreet = street;
			this.street_search = street.title;
			this.initialFilter = true;
			this.fetchData();
			this.initialFilter = false;
		},
		parcel_dataHead() {
			if (!this.isMobile) {
				return "גוש/חלקה/תת-חלקה";
			} else {
				return "תת-חלקה";
			}
		},
		login() {
			this.mixin_goTo(this, "login");
		},
		tuggleShare() {
			this.showShare = !this.showShare;
		},
		computeTargetPath(pageType, pageMethod) {
			// Your conditional logic to determine the target path
			// if (this.$store.state.previousRoutes.length > 1) {
			//   //alert(this.$store.state.previousRoute);
			//   return this.$store.state.previousRoutes[1]
			// }
			//else {
			var searchId = null;
			if (pageType == "neighborhood") {
				searchId = this.$store.state.neighborhoodId;
			}
			if (pageType == "settlement") {
				searchId = this.$store.state.setlCode;
			}
			if (pageType == "neighborhood" && pageMethod == "buy") {
				return "/neighborhood/" + searchId + "/buy/deals";
			}
			if (pageType == "neighborhood" && pageMethod == "rent") {
				return "/neighborhood/" + searchId + "/rent/pricing";
			}
			if (pageType == "settlement" && pageMethod == "buy") {
				return "/settlement/" + searchId + "/buy/deals";
			}
			if (pageType == "settlement" && pageMethod == "rent") {
				return "/settlement/" + searchId + "/rent/pricing";
			}
			//info
			if (pageType == "neighborhood" && pageMethod == "info") {
				return "/neighborhood/" + searchId + "/buy/info";
			}
			if (pageType == "settlement" && pageMethod == "info") {
				return "/settlement/" + searchId + "/buy/info";
			}
			//}
		},
		updateUrl(addressId) {
			//if (this.$route.params.addressId != addressId) {
			if (
				this.$route.query.id != addressId// &&
				//this.$route.query.view != "address"
			) {
				const origin = window.location.origin;
				const target = "view=address&id=" + addressId + "&page=deals";
				// redirect to origin + target
				//console.log(origin + "/?" + target);
				window.location.href = origin + "/?" + target;

				// this.$router.push({
				//    name: "address",
				//    params: { addressId: addressId },
				// });
				setTimeout(() => {
					//window.location.reload();
					//go to top
					window.scrollTo(0, 0);
				}, 10);
			}
		},

		updateUrlParcel(polygonId) {
			if (polygonId.includes("-")) {
				//console.log("polygonId", polygonId);
				if (this.$route.params.kParcel != polygonId) {
					this.$router.push({
						name: "kparcel_all",
						params: { kParcel: polygonId },
					});
					setTimeout(() => {
						window.location.reload();
						//go to top
						window.scrollTo(0, 0);
					}, 10);

					var params = {
						layerName: "KSHTANN_ASSETS",
						fieldName: "ID",
						fieldValues: [polygonId],
						highlight: true,
					};
					/* global govmap */
					govmap.searchInLayer(params);

					window.location.reload();
				}
			}
		},
		updateUrlStreet(streetCode) {
			if (this.$route.params.streetCode != streetCode) {
				this.$router.push({
					name: "street",
					params: { streetCode: streetCode },
				});

				setTimeout(() => {
					window.location.reload();
					//go to top
					window.scrollTo(0, 0);
				}, 10);
			}
		},

		zoomRow(e) {
			const polygonId = e.polygonId;

			govmap.searchInLayer({
				layerName: "KSHTANN_ASSETS",
				fieldName: "POLYGON_ID",
				fieldValues: [polygonId],
				highlight: true,
				outLineColor: [0, 0, 255, 1],
				fillColor: [0, 0, 255, 0.3],
			});

			//scroll to map div (is view!=addres or view!=kparcel_all)
			// if (this.$route.query.view != "address" && this.$route.query.view != "kparcel_all") {
			// 	this.$store.state.showMap = true;
			// 	document.querySelector("#map").scrollIntoView({ behavior: "smooth", block: "center" });
			// }
		},
		filterDealsPeriods(value, text) {
			this.deal_date = value;
			//this.currentFetchNumber = 1;
			//this.currentPage = 1;
			this.initialFilter = true;
			this.fetchData();
			this.initialFilter = false;
			this.selectedDealsPeriod = text;
		},
		filterAssetType(value, text) {
			this.selectedAssetType = text;
			if (text == "כל סוגי הנכסים") {
				this.deal_nature = "";
			} else {
				this.deal_nature = text;
			}
			//this.currentFetchNumber = 1;
			//this.currentPage = 1;
			this.initialFilter = true;
			this.fetchData();
			this.initialFilter = false;
		},
		filterDealType(value, text) {
			// filterDealType יד ראשונה first_hand
			// filterDealType יד שניה second_hand
			// filterDealType כל העסקאות all

			if (text == "כל העסקאות") {
				this.hok_hamecher = "";
			} else if (text == "יד ראשונה") {
				this.hok_hamecher = "1";
			} else if (text == "יד שניה") {
				this.hok_hamecher = "0";
			}
			//this.currentFetchNumber = 1;
			//this.currentPage = 1;
			this.initialFilter = true;
			this.fetchData();
			this.initialFilter = false;
			this.selectedDealType = text;
		},
		goToNeighborhood(neighborhoodId) {
			const baseUrl = window.location.protocol + "//" + window.location.host;
			const newPath = baseUrl + `/neighborhood/${neighborhoodId}/buy/deals`;

			window.location.href = newPath;
		},
		tableSort(sortValue) {
			this.type_order = sortValue;
			this.initialFilter = true;
			this.fetchData();
			this.initialFilter = false;
		},
		tableSort1(sortValue) {
			this.selectedSortOption = sortValue;

			switch (sortValue) {
				case "dateDesc":
					this.$store.state.deals.sort(
						(a, b) => new Date(a.dealDate) - new Date(b.dealDate),
					);
					break;
				case "dateAsc":
					this.$store.state.deals.sort(
						(a, b) => new Date(b.dealDate) - new Date(a.dealDate),
					);
					break;
				case "priceDesc":
					this.$store.state.deals.sort(
						(a, b) =>
							parseFloat(a.dealAmount.replace(/,|₪/g, "")) -
							parseFloat(b.dealAmount.replace(/,|₪/g, "")),
					);
					break;
				case "priceAsc":
					this.$store.state.deals.sort(
						(a, b) =>
							parseFloat(b.dealAmount.replace(/,|₪/g, "")) -
							parseFloat(a.dealAmount.replace(/,|₪/g, "")),
					);
					break;
				case "roomNumDesc":
					this.$store.state.deals.sort((a, b) => a.roomNum - b.roomNum);
					break;
				case "roomNumAsc":
					this.$store.state.deals.sort((a, b) => b.roomNum - a.roomNum);
					break;
				default:
					this.$store.state.deals.sort(
						(a, b) => new Date(a.dealDate) - new Date(b.dealDate),
					);
					break;
			}
		},
		toggleShowFilter() {
			this.showFilterOptions = !this.showFilterOptions;
			if (this.showFilterOptions) {
				this.showRoomsMenu = false;
				this.showSort = false;
			}
		},
		toggleShowSort() {
			this.showSort = !this.showSort;
			if (this.showSort) {
				this.showRoomsMenu = false;
				this.showFilterOptions = false;
			}
		},
		isSelected(roomValue) {
			return this.selectedRooms.includes(roomValue);
		},
		toggleRoom(roomValue) {
			this.page = 1;
			if (this.isSelected(roomValue)) {
				this.selectedRooms = this.selectedRooms.filter(
					(value) => value !== roomValue,
				);
			} else {
				this.selectedRooms.push(roomValue);
			}
			// fetchData again
			this.initialFilter = true;
			this.fetchData();
			this.initialFilter = false;
		},
		customSort(a, b) {
			return a.toDate() - b.toDate();
		},
		go() {
			// // check if last <page
			// if (this.currentPage == this.totalPages - 1){
			// 	// scroll on top of the table
			// 	document.querySelector('#next').scrollIntoView({ behavior: 'smooth' });

			// }
			
			// decompress user
			var userData = this.currentUser;

			if (this.currentPage >= 100) {
				if (userData == null || userData.Verified == false) {
					this.$store.state.userLimitModal = true;
					return;
				} else {
					this.$store.state.userLimitModal = false;
				}
			}
			if (this.currentPage < this.totalPages) {
				this.currentPage++;
				this.updateTransactions();
			}
		},
		updateTransactions() {
			const newFetchNumber = Math.floor((this.currentPage - 1) / 50) + 1;
			if (newFetchNumber !== this.currentFetchNumber) {
				//alert("newFetchNumber" + newFetchNumber);
				this.currentFetchNumber = newFetchNumber;
				this.transactions = [];
				this.fetchData();
			} else {
				this.displayTransactions();
			}
		},
		go2() {
			if (this.page < this.roundPages) {
				this.page = this.page + 1;
			}
		},
		goBack2() {
			if (this.page > 1) {
				this.page = this.page - 1;
			}
		},
		goBack() {
			if (this.currentPage > 1) {
				this.currentPage--;
				this.updateTransactions();
			}
		},
		toggleCollapse(index) {
			this.selectedRow = this.selectedRow === index ? null : index;
		},
		isCollapsed(index) {
			return this.$store.state.deals[index].collapsed;
		},
		selectTab(tab) {
			//save on store
			this.$store.state.selectedTab = tab.key;
			this.tabs.forEach((t) => {
				const element = document.querySelector(
					`[data-rb-event-key="${t.key}"]`,
				);
				if (element) {
					element.classList.remove("active");
				}
			});

			//this.selectedTab = tab.key;
			const selectedElement = document.querySelector(
				`[data-rb-event-key="${tab.key}"]`,
			);
			if (selectedElement) {
				selectedElement.classList.add("active");
			}
		},

		async waitMapLoaded() {
			//this.$store.state.showMap = true;
			if (this.mapSet) {
				return;
			}
			await this.mixin_wait_scriptLoadedIsTrue();
			if (this.$store.state.setlCode == null) {
				await this.mixin_waitForSetlUpdate(this);
			}
			setTimeout(() => {
				this.mixin_createMap(this);
				this.mixin_setMap(this);
				this.$store.state.showMap = false;
			}, 500);
		},

		async fetchData() {
			this.inProgress = true;
			const requestData = {
				base_id: this.base_id,
				base_name: this.base_name,
				fetch_number: this.currentFetchNumber,
				type_order: "dealDate_down",
				// ... and so on
			};

			// when fetching deals from map selection...
			if (this.$store.state.polygonIds.length > 0) {
				//convert ids to string list (like this: "'52162339','52315168','53271034'")
				var string_ids = this.$store.state.polygonIds.map(function (item) {
					return "'" + item + "'";
				});
				requestData.listPolygonId = "(" + string_ids.join(",") + ")";
				requestData.polygonSetlCode = this.$store.state.polygonSetlCode;
				requestData.base_id = "";
				requestData.base_name = "";
			}


			if (this.initialFilter) {
				this.currentFetchNumber = 1;
				this.currentPage = 1;
			}

			if (this.selectedRooms.length > 0) {
				requestData.room_num = this.selectedRooms.join(",");
			}

			if (this.type_order) {
				requestData.type_order = this.type_order;
				//this.currentFetchNumber = 1;
				//this.currentPage = 1;
			}
			if (this.hok_hamecher) {
				requestData.hok_hamecher = this.hok_hamecher;
				//this.currentFetchNumber = 1;
				//this.currentPage = 1;
			}
			if (this.deal_nature) {
				requestData.deal_nature = this.deal_nature;
				//this.currentFetchNumber = 1;
				//this.currentPage = 1;
			}
			if (this.deal_date) {
				requestData.deal_date = this.deal_date;
				//this.currentFetchNumber = 1;
				//this.currentPage = 1;
			}
			if (this.selectedStreet != null) {
				requestData.base_id = this.selectedStreet.id;
				requestData.base_name = "streetCode";
			}

			requestData.fetch_number = this.currentFetchNumber;
			const token = await this.mixin_generateToken();
			requestData.sk = token;
			//decompressed
			var userData;
			if (this.mixin_getCookie("user")) {
				userData = this.decompressBase64Gzip(this.mixin_getCookie("user"));
			}
			if (userData) {
				requestData.email = userData.useremail;
				requestData.userid = userData.userid;
			}
			const myHeaders = new Headers();
			myHeaders.append("Content-Type", "text/plain");
			var requestDataGen = await this.mixin_generateTokenForPayload(requestData);
			const raw = JSON.stringify(requestDataGen);
			const requestOptions = {
				method: "POST",
				headers: myHeaders,
				body: raw,
				redirect: "follow",
			};
			var appVue = this;

			fetch(appVue.$store.state.config.api_base + "/deal", requestOptions)
				.then((response) => response.json())
				.then((data) => {
					// decompressBase64Gzip
					var data = this.decompressBase64Gzip(data);
					if (data.statusCode == 403) {
						// user is not approved
						this.$store.state.userLimitModal = true;
						return;
					}
					if (data.data.items.length == 0) {
						// if type is address
						if (requestData.base_name == "addressId") {

							// get the address name
							//const addressName = appVue.$store.state.addrName;
							// Get address xy from govmap
							//var url = "https://es.govmap.gov.il/TldSearch/api/AutoComplete?query=" + addressName + ", " + appVue.$store.state.settlementName + "&ids=276267023&gid=govmap";
							//console.log("url", url);
						}
						appVue.transactions = [];
						appVue.totalPages = 0;
						appVue.displayTransactions();
						appVue.total_rows = 0;
						this.inProgress = false;
						return;
					}
					// filter prevDeals
					for (var i = 0; i < data.data.items.length; i++) {
						var element = data.data.items[i];
						if (data.data.items[i].hasOwnProperty("prevDeals")) {
							if (element.trend.rate == 0 ||
								element.trend.years == 0 ||
								element.trend.years > 9 && element.trend.rate > 500 ||
								element.trend.years > 2 && element.trend.rate < -50 ||
								// current year
								element.yearBuilt >= new Date().getFullYear()){
									// exclude i from prevDeals
									data.data.items[i].prevDeals = [];
							}
						}
					}
					appVue.setFancyRows(data.data);
					appVue.transactions = data.data.items;
					appVue.totalPages = Math.ceil(data.data.total_rows / 10);
					appVue.displayTransactions();
					appVue.total_rows = data.data.total_rows;
					this.inProgress = false;
				})
				.catch((error) => console.error(error));
		},
		displayTransactions() {
			const startIndex = ((this.currentPage - 1) % 50) * 10;
			const endIndex = startIndex + 10;
			this.currentTransactions = this.transactions.slice(startIndex, endIndex);
		},
		setFancyRows(e) {
			e.items.forEach((element) => {
				element.dealAmount = element.dealAmount.toLocaleString("he-IL") + " ₪";
				// get date
				// exmple: 2023-02-09T02:00:00+02:00
				// format to 'DD/MM/YYYY'
				const date = new Date(element.dealDate);
				var parentDealDate = element.dealDate;
				const day = date.getDate().toString().padStart(2, "0");
				const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Month is zero-based, so we add 1
				const year = date.getFullYear();
				const formattedDate = `${day}/${month}/${year}`;
				element.dealDate = formattedDate;
				//if (element.hasOwnProperty("prevDeals")) {
				if (Object.keys(element).includes("prevDeals")) {
					element.prevDeals.forEach((i) => {
						if (i.dealDate == parentDealDate ||
							element.trend.rate == 0 ||
							element.trend.years == 0 ||
							element.trend.years > 9 && element.trend.rate > 300 ||
							element.trend.years > 2 && element.trend.rate < -50 ||
							// current year
							element.yearBuilt >= new Date().getFullYear()
						) {
							// exclude i from prevDeals
							element.prevDeals.splice(
								element.prevDeals.indexOf(i),
								1,
							);
							return;
						}
						const date = new Date(i.dealDate);
						const day = date.getDate().toString().padStart(2, "0");
						const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Month is zero-based, so we add 1
						const year = date.getFullYear();
						const formattedDate = `${day}/${month}/${year}`;
						i.dealDate = formattedDate;
					});
				}
				//trend
				let rate = element.trend.rate;
				let years = element.trend.years;
				let trend = `${rate}% ב ${years} שנים`;
				//trend
				if (
					//element.trend.hasOwnProperty("rate") == false ||
					!Object.keys(element.trend).includes("rate") ||
					element.trend.rate == 0 ||
					element.trend.years == 0 ||
					element.trend.years > 9 && element.trend.rate > 300 ||
					element.trend.years > 2 && element.trend.rate < -50 ||
					// current year
					element.yearBuilt >= new Date().getFullYear()
				) {
					element.trend_text = "";
				} else {
					element.trend_text = trend;
				}
				//adrress
				if (element.address == 0) {
					element.address = "";
				}
			});
		},
		async loadConfig() {
			await this.$store.dispatch("loadConfig");
		},
		upOrDown_deal(trend_text) {
			if (trend_text.includes("-")) {
				//return "/images/arrowRed.svg";
				return `<svg xmlns="http://www.w3.org/2000/svg" width="12px" height="12px" viewBox="0 0 12 12" version="1.1">
							<title>tooltip 16 copy</title>
							<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
								<g transform="translate(-1210.000000, -811.000000)">
									<g transform="translate(1209.000000, 810.000000)">
										<g transform="translate(7.000000, 7.000000) rotate(-180.000000) translate(-7.000000, -7.000000)">
											<rect fill="#FF0000" x="6" y="3" width="2" height="10" rx="1"/> <!-- Change color to red -->
											<polyline stroke="#FF0000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" transform="translate(7.000000, 5.000000) rotate(-270.000000) translate(-7.000000, -5.000000)" points="10 10 4 5 10 0"/> <!-- Change color to red -->
										</g>
									</g>
								</g>
							</g>
						</svg>
						`;
			} else {
				//return "/images/arrowGreen.svg";
				return `<svg xmlns="http://www.w3.org/2000/svg" width="12px" height="12px" viewBox="0 0 12 12" version="1.1">
							<title>green arrow up</title>
							<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
								<g transform="translate(-1210.000000, -811.000000)">
									<g transform="translate(1209.000000, 810.000000)">
										<g transform="translate(7.000000, 7.000000) translate(-7.000000, -7.000000)">
											<rect fill="#66bb6a" x="6" y="3" width="2" height="10" rx="1"/>
											<polyline stroke="#66bb6a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" transform="translate(7.000000, 5.000000) rotate(90.000000) translate(-7.000000, -5.000000)" points="10 10 4 5 10 0"/>
										</g>
									</g>
								</g>
							</g>
						</svg>`;
			}
		},
		upOrDown_color(trend_text) {
			if (trend_text.includes("-")) {
				return { color: "#E57373" };
			} else {
				return { color: "#66BB6A" };
			}
		},
	},

	mounted() {
		//loadConfig
		var appVue = this;

		// loadConfig
		//send scroll page to top:
		window.scrollTo(0, 0);
		if (this.$store.state.config == null) {
			appVue.loadConfig()
		}
		//appVue.loadConfig().then(() => {
		appVue.$store.state.loading = true;
		appVue.$store.state.setlCode = null;
		appVue.$store.state.isMain = false;
		appVue.waitMapLoaded();
		// fetch dealNatureIndex json object
		fetch(this.$store.state.config.deal_nature_index)
			.then((response) => response.json())
			.then((data) => {
				appVue.dealNatureIndex = data;
			});
		var view = this.$route.query.view;
		var id = this.$route.query.id;

		var baseNames = {
			neighborhood: "neighborhoodId",
			settlement: "settlmentID",
			street: "streetCode",
			address: "addressId",
			kparcel_all: "kParcelName",
		};

		this.base_name = baseNames[view];
		this.base_id = id;
		// 
		if (view == "settlement" || view == "neighborhood") {
			this.fetchData();
		}
		//this.fetchData();

		document.addEventListener("click", function (event) {
			const inputElement1 = document.getElementById("leftFilters");
			if (inputElement1 == null) {
				return;
			}
			// Check if the click is outside the input and the streetDrop div
			if (!inputElement1.contains(event.target)) {
				// Action to take when clicked outside
				appVue.showSuggestions = false;
				// check selected street
				if (appVue.selectedStreet != null) {
					appVue.street_search = appVue.selectedStreet.title;
				} else {
					appVue.street_search = "";
					// take first 10 items from streets
					appVue.filteredStreets = appVue.streets;
				}
			}
		});

			//appVue.mixin_setMap(appVue);
		//});
	},
	watch: {
		// selectionType(before, after) {
		// 	if (before == null && after != null) {
		// 		//clear all
		// 		this.$store.state.polygonIds = [];
		// 		this.$store.state.polygonSetlCode = null;
		// 		this.$store.state.mapSelectionAllowed = true;
				
		// 		this.fetchData();
		// 	}
		// },
		mapStatus(before, after) {
				var appVue = this;
				if (appVue.zoomingTo == true) {
					return;
				}
				if (appVue.mapStatus > 0) {
					appVue.zoomingTo = true;
					setTimeout(() => {
						var view = appVue.$route.query.view;
						if (view == "neighborhood_info") {
							//filter and zoom
							var params = {
								layerName: "KSHTANN_NEIGHBORHOODS",
								whereClause: "UNIQ_ID = " + appVue.$store.state.neighborhoodId,
								zoomToExtent: true,
							};
							govmap.filterLayers(params);
						} else if (view == "settlement_info") {
							// filter and zoom
							var params = {
								layerName: "KSHTANN_SETL_AREA",
								whereClause: "SETL_CODE = " + appVue.$store.state.setlCode,
								zoomToExtent: true,
							};
							govmap.filterLayers(params);
						} else {
							//zoom to settlement or neighborhood
							appVue.mixin_setMap(appVue);
							appVue.zoomingTo = false;
							return;
						}
						appVue.zoomingTo = false;
					}, 1000);
				}
			},
		street_search(newVal) {
			if (newVal === "") {
				this.showSuggestions = false;
			}
		},
		showRoomsMenu() {
			if (this.showRoomsMenu) {
				this.showFilterOptions = false;
				this.showSort = false;
			}
		},
		selectedTab() {
			//store
			this.$store.state.selectedTab = this.selectedTab;
			// get graph_component ref
		
		},
		// currentTab() {
		//   this.updateGraphData();
		// },
		showMap: function (val) {
			if (val && !this.mapSet) {
				//only once...
				setTimeout(() => {
					this.mapSet = true;
					this.mixin_setMap(this);
				}, 500);
			}
		},
		showAssetTypes: function (val) {
			if (val) {
				this.showDealsPeriods = false;
				this.showDealTypes = false;
			}
		},
		showDealsPeriods: function (val) {
			if (val) {
				this.showAssetTypes = false;
				this.showDealTypes = false;
			}
		},
		showDealTypes: function (val) {
			if (val) {
				this.showAssetTypes = false;
				this.showDealsPeriods = false;
			}
		},
	},
	computed: {

		currentUser() {
			if (this.mixin_getCookie("user")) {
				// decompress user
				var decompressed = this.decompressBase64Gzip(this.mixin_getCookie("user"));
				//console.log('decompressed', decompressed);
				if (decompressed != null) {
					this.$store.state.currentUser = decompressed;//this.mixin_getCookie("user");
					return this.$store.state.currentUser;
				}
				else{
					this.$store.state.currentUser = null;
					return this.$store.state.currentUser;
				}
				// in the future, get user from server...
			}
			return this.$store.state.currentUser;
		},

		selectionType(){
			return this.$store.state.mapSelectionType;
		},
		mapStatus(){
				return this.$store.state.mapStatus;
			},

		showMap() {
			return this.$store.state.showMap;
		},
		street_search_placeholder() {
			// if (this.selectedStreet) {
			// 	return this.selectedStreet.title;
			// }
			return "סינון לפי רחוב";
		},
		streets() {
			// if ?view=settlement (from url)
			var page_streets = [];
			if (this.$route.query.view == "settlement") {
				//otherSettlmentStreets
				// set unique streets (by title)... + sort by title
				if (this.$store.state.otherSettlmentStreets.length > 0) {
					page_streets = this.$store.state.otherSettlmentStreets
						.filter(
							(street, index, self) =>
								index === self.findIndex((t) => t.id === street.id),
						)
						.sort((a, b) => a.title.localeCompare(b.title));
				}
			}
			if (this.$route.query.view == "neighborhood") {
				// set unique streets (by title)... + sort by title
				page_streets = this.$store.state.similarStreets
					.filter(
						(street, index, self) =>
							index === self.findIndex((t) => t.id === street.id),
					)
					.sort((a, b) => a.title.localeCompare(b.title));
			}
			// רקremove 'כל הרחובות' from list
			page_streets = page_streets.filter(
				(street) => street.title != "כל הרחובות",
			);

			return page_streets;
		},
		isMobile() {
			return window.innerWidth < 1024;
		},
		maxPrice() {
			return (
				Math.max(
					...this.settlementPrices.filter((price) => price),
					...this.countryPrices.filter((price) => price),
					...this.neighborhoodPrices.filter((price) => price),
				) * 1.1
			);
		},
		minPrice() {
			return (
				Math.min(
					...this.settlementPrices.filter((price) => price),
					...this.countryPrices.filter((price) => price),
					...this.neighborhoodPrices.filter((price) => price),
				) * 0.9
			);
		},
		graphData() {
			return (
				this.allData.find(
					(data) => data.numRooms.toString() === this.currentTab,
				)?.graphData || []
			);
		},
		labels() {
			return this.graphData
				.map((entry) => `${entry.year}/${entry.month}`)
				.reverse();
		},
		settlementPrices() {
			return this.graphData.map((entry) => entry.settlementPrice).reverse();
		},
		countryPrices() {
			return this.graphData.map((entry) => entry.countryPrice).reverse();
		},
		neighborhoodPrices() {
			return this.graphData.map((entry) => entry.neighborhoodPrice).reverse();
		},
		chartData() {
			return {
				labels: this.labels,
				datasets: [
					{
						label: "מחיר בשכונה",
						fill: false,
						backgroundColor: "#056db3",
						borderColor: "#056db3",
						data: this.neighborhoodPrices,
						borderDash: [5, 5],
						borderWidth: 1,
					},
					{
						label: "מחיר ביישוב",
						fill: false,
						backgroundColor: "grey",
						borderColor: "grey",
						borderDash: [5, 5],
						borderWidth: 1,

						data: this.settlementPrices,
					},
					{
						label: "מחיר ממוצע ארצי",
						backgroundColor: "rgb(54, 162, 235)",
						borderColor: "rgb(54, 162, 235)",
						data: this.countryPrices,
						fill: false,
						borderDash: [5, 5],
						borderWidth: 1,
					},
				],
			};
		},
		chartOptions() {
			return {
				legend: {
					display: false,
				},

				responsive: true,
				scales: {
					x: {
						// display: true,
						type: "category",
						ticks: {
							autoSkip: false,
						},
					},
					y: {
						// display: true,
						beginAtZero: false,
						suggestedMax: this.maxPrice,
						suggestedMin: this.minPrice,
					},
				},
				plugins: {
					tooltip: {
						enabled: true,
					},
					legend: {
						labels: {
							generateLabels: (chart) => {
								const datasets = chart.data.datasets;
								return datasets
									.map((dataset, i) => {
										const label = dataset.label;

										if (
											this.typePage === "settlement" &&
											"מחיר בשכונה" === label
										) {
											return null;
										}
										return {
											text: label,
											fillStyle: dataset.backgroundColor,
											hidden: false,
											index: i,
										};
									})
									.filter((item) => item !== null);
							},
						},
					},
				},
			};
		},

		upOrDown_s() {
			if (this.$store.state.priceIncreases > 0) {
				return "עלו";
			} else if (this.$store.state.priceIncreases < 0) {
				return "ירדו";
			} else {
				return null;
			}
		},
		buy_path() {
			if (typeof this.mixin_computeTargetPath().buy == "undefined") {
				return "/";
			}
			return this.mixin_computeTargetPath().buy;
		},
		rent_path() {
			if (typeof this.mixin_computeTargetPath().rent == "undefined") {
				return "/";
			}
			return this.mixin_computeTargetPath().rent;
		},
		info_path() {
			if (typeof this.mixin_computeTargetPath().info == "undefined") {
				return "/";
			}
			return this.mixin_computeTargetPath().info;
		},
		checkRouteType() {
			var st = this.$route.query.view;
			return st;
		},
		checkAddress() {
			// if (this.$store.state.addrName != null) {
			// 	return this.$store.state.addrName;
			// }
			if (this.checkRouteType == "kparcel_all") {
				//return this.$route.params.kParcel;
				return this.$route.query.id;
			}

			var addrs = [];
			var streets = {};
			if (this.selectedDeals.length == 0) {
				if (this.checkRouteType == "address") {
					return this.$store.state.addrName;
				}
				if (this.checkRouteType == "street") {
					return this.$store.state.streetName;
				}
				if (this.checkRouteType == "kparcel_all") {
					return this.$store.state.kParcel;
				}
				if (this.checkRouteType == "neighborhood") {
					return this.$store.state.neighborhoodName;
				}
				if (this.checkRouteType == "settlement") {
					return this.$store.state.settlementName;
				}

			}
			this.selectedDeals.forEach(function (deal) {
				if (!addrs.includes(deal.address)) {
					var strName = deal.address.replace(/\d+$/, "").trim();
					var houseNum = deal.address.replace(strName, "").trim();
					//if (!streets.hasOwnProperty(strName)) {
					if (Object.keys(streets).includes(strName) == false) {
						streets[strName] = [houseNum];
					}
					if (!streets[strName].includes(houseNum)) {
						streets[strName].push(houseNum);
					}
					addrs.push(deal.address);
				}
			});
			//

			if (this.checkRouteType == "address") {
				var addrsStr = "";
				var entries = Object.entries(streets);
				// collect all house numbers for each street
				entries.forEach(function (entry) {
					var streetName = entry[0];
					var houseNums = entry[1];
					//sort house numbers
					houseNums.sort(function (a, b) {
						return a - b;
					});
					var houseNumsStr = houseNums.join(", ");
					addrsStr += streetName + " " + houseNumsStr + ", ";
				});

				// remove last comma
				addrsStr = addrsStr.replace(/,\s*$/, "");
				if (this.$store.state.addrName != null && (addrsStr == "" || addrsStr == null)) {
                    return this.$store.state.addrName;
                }
				return addrsStr;
			} else if (this.checkRouteType == "street") {
				if (addrs.length > 0) {
					var firstAddr = addrs[0];

					var streetName = firstAddr.replace(/\d+$/, "");
					return streetName;
				} else {
					return "";
				}
			} else {
				return "";
			}

			//});
		},
		roomsDisplay() {
			if (this.selectedRooms.length > 0 && this.selectedRooms.length < 6) {
				return this.selectedRooms.join(", ") + " חדרים";
			} else {
				return "כל החדרים";
			}
		},
		roundPages() {
			//
			if (this.$store.state.deals.length != this.countDealsAll) {
				return Math.round(this.countDealsAll / 10);
			}
			return Math.round(this.$store.state.total / 10);
			//}
		},
		countDeals() {
			if (this.selectedRooms.length > 0) {
				//filter this.$store.state.deals with selected rooms
				return this.$store.state.deals.filter((deal) =>
					this.selectedRooms.includes(deal.roomNum),
				).length;
			} else {
				return this.$store.state.deals.length;
			}
		},
		//
		selectedDeals() {
			return this.currentTransactions;
		},
		summaryTypeName() {
			if (("summaryTypeName", this.$store.state.neighborhoodId > 0)) {
				return "שכונה";
			}
			return "ישוב";
		},
		resultTypeDesc() {
			//var st = this.$route.name;
			var st = this.$route.query.view;
			if (this.$store.state.polygonIds.length > 0){
				return "אזור הנבחר";				
			}
			if (st == "address") {
				return "כתובת";
			} else if (st == "street") {
				return "רחוב";
			} else if (st == "neighborhood") {
				return "שכונה";
			} else if (st == "settlement") {
				return "יישוב";
			} else if (st == "kparcel_all") {
				return "גוש חלקה";
			} else {
				return "כתובת";
			}
		},
		
		getLastYearAvgPrice() {
			if (this.selectedTab == "all") {
				if (this.$store.state.lastYearAvgPrice == null) {
					return null;
				}
				return this.$store.state.lastYearAvgPrice.toLocaleString("he-IL");
			} else if (this.selectedTab == "3") {
				if (this.$store.state.lastYearAvgPrice_3 == null) {
					return null;
				}
				return this.$store.state.lastYearAvgPrice_3.toLocaleString("he-IL");
			} else if (this.selectedTab == "4") {
				if (this.$store.state.lastYearAvgPrice_4 == null) {
					return null;
				}
				return this.$store.state.lastYearAvgPrice_4.toLocaleString("he-IL");
			} else if (this.selectedTab == "5") {
				if (this.$store.state.lastYearAvgPrice_5 == null) {
					return null;
				}
				return this.$store.state.lastYearAvgPrice_5.toLocaleString("he-IL");
			} else {
				return null;
			}
		},
		getLastQuarterlyAvgPrice() {
			if (this.selectedTab == "all") {
				if (this.$store.state.lastQuarterlyAvgPrice == null) {
					return null;
				}
				return this.$store.state.lastQuarterlyAvgPrice.toLocaleString("he-IL");
			} else if (this.selectedTab == "3") {
				if (this.$store.state.lastQuarterlyAvgPrice_3 == null) {
					return null;
				}
				return this.$store.state.lastQuarterlyAvgPrice_3.toLocaleString(
					"he-IL",
				);
			} else if (this.selectedTab == "4") {
				if (this.$store.state.lastQuarterlyAvgPrice_4 == null) {
					return null;
				}
				return this.$store.state.lastQuarterlyAvgPrice_4.toLocaleString(
					"he-IL",
				);
			} else if (this.selectedTab == "5") {
				if (this.$store.state.lastQuarterlyAvgPrice_5 == null) {
					return null;
				}
				return this.$store.state.lastQuarterlyAvgPrice_5.toLocaleString(
					"he-IL",
				);
			} else {
				return null;
			}
		},
		upOrDown() {
			if (this.getPriceDifferencePercentage < 0) {
				return "ירידת מחירים";
			} else {
				return "עליית מחירים";
			}
		},
		getPriceDifferencePercentage() {
			if (this.selectedTab == "all") {
				return this.$store.state.priceDifferencePercentage;
			} else if (this.selectedTab == "3") {
				return this.$store.state.priceDifferencePercentage_3;
			} else if (this.selectedTab == "4") {
				return this.$store.state.priceDifferencePercentage_4;
			} else if (this.selectedTab == "5") {
				return this.$store.state.priceDifferencePercentage_5;
			} else {
				return null;
			}
		},
	},
};
</script>

<style scoped>




@media screen and (max-width: 1350px) {
	.map_side_wrapper {
		width: 100%;
	}

}




.tableAction {
	display: flex;
	justify-content: space-between;
}

.filtersBtnsContainer {
	flex: 1; /* This will take the remaining width */
}

#rightFilters {
	flex: 0 0 auto; /* This will allow it to take its width */
	width: auto; /* Or set a specific width */
}

#leftFilters {
	margin-right: 12px;
}

@media screen and (min-width: 1024px) {
	.filtersBtnsContainer {
		max-width: 250px;
	}
}

.streetDrop {
	max-height: 300px;
	overflow-x: auto; /* Horizontal scroll */
	overflow-y: hidden; /* Prevent vertical scrolling */
	background-color: #ffffff;
}

.streetDrop::-webkit-scrollbar {
	border-radius: 5px;
	width: 5px;
	background-color: transparent;
	height: 4px; /* Height of the scrollbar */
}

.streetDrop::-webkit-scrollbar-track {
	background: transparent; /* Color of the tracking area */
	border-radius: 15px;
}

.streetDrop::-webkit-scrollbar-thumb {
	background-color: #888; /* Scrollbar thumb color */
	border-radius: 45px; /* Rounded corners */
	border: 4px solid #484545; /* Padding around the thumb */
	height: 100px;
}

/* Change thumb color when hovered */
.streetDrop::-webkit-scrollbar-thumb:hover {
	background: #555;
	border-radius: 15px;
}

button:disabled {
	cursor: wait;
}
.scrollmenu-container {
	/* ... other styles ... */

	/* Add transition for smooth scroll animation */
	transition: scroll-left 0.3s ease-in-out;
}
.grid-container {
	display: grid;
	grid-template-columns: 10% 80% 10%; /* Three columns: 10%, 80%, 10% */
	align-items: center; /* Optional: Centers items vertically within the grid container */
	/* ... other styles ... */
}

div.scrollmenu {
	display: block;
	overflow: auto;
	white-space: nowrap;
	z-index: -1;
	margin-top: 120px;
}

div.scrollmenu a {
	display: inline-block;
	color: white;
	text-align: center;
	padding: 14px;
	text-decoration: none;
	z-index: -1;
	color: black;
}

div.scrollmenu a:hover {
	background-color: tr;
	z-index: -1;
}

.details-row {
	display: none;
}
.fade-enter-active {
	transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-active {
	opacity: 0;
}

.filter_circle {
	width: 20px;
	height: 20px;
	border-radius: 50%;
	border: 2px solid blue;
	border-top: 2px solid transparent;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%) rotate(0deg);
	animation: spin 2s linear infinite;
}

.sort_circle {
	width: 20px;
	height: 20px;
	border-radius: 50%;
	border: 2px solid blue;
	border-top: 2px solid transparent;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%) rotate(0deg);
	animation: spin 2s linear infinite;
}

.filter_rooms_circle {
	width: 20px;
	height: 20px;
	border-radius: 50%;
	border: 2px solid blue;
	border-top: 2px solid transparent;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%) rotate(0deg);
	animation: spin 2s linear infinite;
}

@keyframes spin {
	0% {
		transform: translate(-50%, -50%) rotate(0deg);
	}
	100% {
		transform: translate(-50%, -50%) rotate(360deg);
	}
}

#wrapper {
	position: relative;
	/*background:#333;*/
	height: 100%;
}

.profile-main-loader {
	position: fixed !important;
	left: 50%;
	right: 50%;
	top: 50%;
	bottom: 50%;
	width: 300px;
	height: 300px; /* assuming you want it square */
	margin-left: -100px; /* half of the width */
	margin-top: -100px; /* half of the height */
	z-index: 900 !important;
}

.profile-main-loader .loader {
	position: relative;
	margin: 0px auto;
	width: 150px;
	height: 150px;
}
.profile-main-loader .loader:before {
	content: "";
	display: block;
	padding-top: 100%;
}

.circular-loader {
	-webkit-animation: rotate 2s linear infinite;
	animation: rotate 2s linear infinite;
	height: 100%;
	-webkit-transform-origin: center center;
	-ms-transform-origin: center center;
	transform-origin: center center;
	width: 100%;
	position: absolute;
	top: 0;
	left: 0;
	margin: auto;
}

.trendsArrow {
	width: 2px;
	height: 12px;
	position: absolute;
	right: 10px;
	background: green;
}

.suggestions-list {
	list-style-type: none;
	padding: 0;
	margin-top: 8px;
	border: 1px solid #ccc;
	background-color: #fff;
	max-height: 200px;
	overflow-y: auto;
}

.suggestions-list li {
	padding: 8px;
	cursor: pointer;
}

.suggestions-list li:hover {
	background-color: #f0f0f0;
}
</style>
